import { gateway } from "../../../gateway";

interface UpdateTimeSheetParams {
  uid: string;
  startAt?: string;
  endAt?: string;
  isDeleted?: boolean;
}

export const updateTimeSheets = async ({ uid, startAt, endAt, isDeleted }: UpdateTimeSheetParams) => {
  const payload: Record<string, any> = {};

  if (startAt !== undefined) payload.startAt = startAt;
  if (endAt !== undefined) payload.endAt = endAt;
  if (isDeleted !== undefined) payload.isDeleted = isDeleted;

  const { data } = await gateway.patch(`/timesheets/event/${uid}`, payload);

  return data;
};
